import axios from "axios";
import * as types from "../mutation-types";
import store from "~/store";
import logger from "~/utilities/logger";

// state
export const state = {
    project_list: [],
    project_select: null,
    the_id: null,
    global_projects: null,
    index_data: null,
};

// getters
export const getters = {
    project_list: (state) => state.project_list,
    index_data: (state) => state.index_data,
    global_projects: (state) => state.global_projects,
    project_select: (state) => state.project_select,
    the_id: (state) => state.the_id,
    check_list: (state) => state.project_list !== null,
    check_global: (state) => state.global_projects !== null,
};

const _filters = {
    format: "minimal",
    paginate: 10000,
    isBooking: false,
    isUserHours: false,
    reindex: false,
    isPM: false,
    extraExcl: "",
    isProjectIndexPage: false,
};

//utils
export const getProjectIndexById = (state, projectId) =>
    state.project_list.findIndex(
        (project) => project.pro_id.toString() === projectId.toString()
    );
export const getProjectByProId = (state, projectId) =>
    state.project_list.find(
        (project) => project.pro_id.toString() === projectId.toString()
    );

// mutations
export const mutations = {
    [types.ADD_PROJECT](state, event)
    {
        return state.project_list.push(event);
    },

    [types.FETCH_PROJECTS](state, { project_list, index_data })
    {
        state.index_data = index_data;

        return (state.project_list = project_list);
    },

    [types.SELECT_PROJECT](state, { pro_id })
    {
        const theProj = getProjectByProId(state, pro_id);

        logger.log("SELECT_PROJECT", theProj);
        return (state.project_select = theProj);
    },

    [types.DESELECT_PROJECT](state)
    {
        return (state.project_select = null);
    },

    [types.FETCH_GLOBAL_PROJECTS](state, { global_projects })
    {
        return (state.global_projects = global_projects);
    },

    [types.FETCH_GLOBAL_PROJECTS_FAILURE](state)
    {
        logger.error("FETCH_GLOBAL_PROJECTS_FAILURE");
    },

    [types.FETCH_PROJECTS_FAILURE](state)
    {
        logger.error("FETCH_PROJECTS_FAILURE");
    },

    [types.FETCH_PROJECT](state, { project_select })
    {
        return (state.project_select = project_select);
    },

    [types.FETCH_PROJECT_FAILURE](state, { error })
    {
        logger.error("FETCH_PROJECT_FAILURE");
        logger.error(error);
    },

    [types.UPDATE_PROJECT](state, project)
    {
        // const index = getProjectIndexById(state, project.pro_id);
        // logger.log("store.UPDATE_PROJECT", project);
        // if (index === -1) {
        //   return console.warn(`Unable to update project (id ${project.pro_id})`);
        // }
    },

    [types.SET_PROJECT_ID](state, { id })
    {
        state.the_id = id;
    },
    [types.DELETE_PROJECT](state, id)
    {
        const index = getProjectIndexById(state, id);

        if (index === -1)
        {
            return console.warn(`Unable to delete project (id ${id})`);
        }

        return state.project_list.splice(index, 1);
    },
    [types.CLEAR_PROJECTS](state)
    {
        state.project_list = null;
    },

    [types.FETCH_OPPORTUNITIES](state, { opportunity_list })
    {
        return (state.opportunity_list = opportunity_list);
    },

    [types.FETCH_OPPORTUNITIES_FAILURE](state)
    {
        logger.error("FETCH_OPPORTUNITIES_FAILURE");
    },
};

// actions
export const actions = {
    addProject({ commit }, project)
    {
        return commit(types.ADD_PROJECT, project);
    },

    clearProjects({ commit })
    {
        return commit(types.CLEAR_PROJECTS);
    },

    async getProjects({ commit }, options = {})
    {
        const paginate = options?.paginate || "10000";
        const with_status = options?.with_status || undefined;
        const the_status = options?.the_status || undefined;
        const extraOptions = options?.extra_options || "";
        const format = options?.format || "minimal";

        logger.log("store.getProjects extraOptions", the_status, with_status, extraOptions);

        const queryStatus = the_status || with_status || "active";

        const url =
            `/api/projects?status=${queryStatus}&format=${format}&paginate=${paginate}${extraOptions}`.toString();

        try
        {
            const { data } = await axios.get(url);

            // console.log(
            //   `store.getProjects the_status: ${the_status} with_status: ${with_status}`,
            //   data
            // );

            const project_list = data?.data?.data || [];
            const index_data = data?.data || [];

            delete data.data.data;

            return commit(types.FETCH_PROJECTS, {
                project_list,
                index_data,
            });
        } catch (e)
        {
            logger.error("store.getProjects 123", e);
            return commit(types.FETCH_PROJECTS_FAILURE);
        }
    },

    async getGlobalProjects({ commit }, options)
    {
        try
        {
            const url = `/api/projects?status=protected&paginate=${options?.paginate || 2
                }&format=minimal`;
            const { data } = await axios.get(url);

            logger.log("store.getGlobalProjects", data);

            return commit(types.FETCH_GLOBAL_PROJECTS, {
                global_projects: data?.data?.data,
            });
        } catch (e)
        {
            logger.error("store.getGlobalProjects", e);
            return commit(types.FETCH_GLOBAL_PROJECTS_FAILURE);
        }
    },

    async getProject({ commit, dispatch }, id)
    {
        try
        {
            const { data } = await axios.get(`/api/projects/${id}`);

            logger.log("store.getProject", data);

            return commit(types.FETCH_PROJECT, { project_select: data.data });
        } catch (e)
        {
            logger.error("store.getProject", e);
            return commit(types.FETCH_PROJECT_FAILURE, { error: e });
        }
    },

    async selectProject({ commit, dispatch }, pro_id)
    {
        logger.log("store.selectProject", pro_id);

        if (!store.getters["projects/check_list"])
        {
            await store.dispatch("projects/getProjects");
        }

        return commit(types.SELECT_PROJECT, { pro_id });
    },

    async deselectProject({ commit, dispatch })
    {
        logger.log("store.deselectProject");
        return commit(types.DESELECT_PROJECT);
    },

    async updateProject({ commit, dispatch }, payload)
    {
        const id = payload.pro_id;

        if (!id) return;

        try
        {
            const { data } = await axios.put(`/api/projects/${id}`, payload);

            logger.log("store.updateProject", data);

            return commit(types.UPDATE_PROJECT, { payload: data?.data });
        } catch (e)
        {
            logger.error("store.updateProject", e);
            return commit(types.FETCH_PROJECT_FAILURE, { error: e });
        }
    },

    async deleteProject({ commit, dispatch }, proj_id)
    {
        if (!proj_id) return;

        logger.log("store.deleteProject", proj_id);
        try
        {
            const { data } = await axios.delete(`/api/projects/${proj_id}`);

            logger.log("store.deleteProject rsp", data);

            return commit(types.DELETE_PROJECT, proj_id);
        } catch (e)
        {
            logger.error("store.deleteProject", e);
            return commit(types.DELETE_PROJECT_FAILURE, { error: e });
        }
    },

    setProjectID({ commit, dispatch }, id)
    {
        commit(types.SET_PROJECT_ID, { id: id });
    },

    async getLocation(filters = {})
    {
        // UID
        const selectedUser = store.getters["users/user_select"];
        const location = selectedUser.state.sta_location;

        if (!location) return;

        try
        {
            // Fetch location
            const locationResponse = await axios.get(`/api/locations/${location}`);
            const countryId = locationResponse?.data?.data?.loc_country_id;

            logger.log("store.setUserCountryByLocation.locations", locationResponse);

            let couID = null;
            if (countryId)
            {
                try
                {
                    // Fetch country
                    const countryResponse = await axios.get(
                        `/api/countries/${countryId}`
                    );
                    couID = countryResponse?.data?.data?.cou_id;
                    logger.log("store.setUserCountryByLocationgetCountry.country", couID);
                } catch (e)
                {
                    logger.error("store.setUserCountryByLocation error", e);
                }
            }

            let extraPm = "";
            if (filters?.isPM)
            {
                logger.log("feeding projects for PM");
                extraPm = "&pm=1";
            }

            let countryQuery = "";
            if (couID)
            {
                countryQuery = `&cou_id=${couID}`;
            }

            const body = {
                extra_options: `${countryQuery}${extraPm}`,
            };

            console.log("store.getLocation", body);

            await store.dispatch("projects/getProjects", body);

            logger.log("feeding projects for selectedUser country ", couID);
        } catch (e)
        {
            logger.error("setUserCountryByLocation error", e);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
